import { useRef } from 'react';
import styles from 'styles/modules/SearchResult.module.scss';
import Link from 'next/link';
import { isObjectEmpty } from 'helpers/objects';
import useFitCount from 'hooks/useFitCount';

// The chip grows to fill the row, so its natural size is the label's width
// plus its own padding and trailing margin.
const chipWidth = (chip) => {
    const range = document.createRange();
    range.selectNodeContents(chip);
    const style = getComputedStyle(chip);
    return ['paddingLeft', 'paddingRight', 'marginRight'].reduce(
        (width, property) => width + parseFloat(style[property]),
        range.getBoundingClientRect().width
    );
};

const SearchResult = ({ item, onClick }) => {
    const tagsRef = useRef(null);
    const plusRef = useRef(null);
    const total = item?.expertise.length ?? 0;
    const visible = useFitCount({
        rowRef: tagsRef,
        buttonRef: plusRef,
        measure: () =>
            [...tagsRef.current.children]
                .filter((child) => child !== plusRef.current)
                .map(chipWidth),
        total,
        max: 5,
        key: item?.expertise.map((tag) => tag.name).join(),
    });

    if (!item) {
        return <div className={styles.itemNoResults}>No results found.</div>;
    }

    return (
        <Link href={`/${item.slug}`}>
            <a className={styles.item} onClick={onClick}>
                <div className={styles.itemRow}>
                    <div className={styles.itemLogo}>
                        {item.logo && (
                            <img src={item.logo.path} alt={item.name} />
                        )}
                    </div>
                    <div className="itemBody">
                        <div className={styles.itemTitle}>{item.name}</div>
                        {!isObjectEmpty(item.addresses[0]) && (
                            <div className={styles.itemAddress}>
                                {item.addresses[0].fullAddress}
                            </div>
                        )}
                    </div>
                </div>
                {total > 0 && (
                    <div
                        ref={tagsRef}
                        className={styles.itemTags}
                        data-nosnippet
                    >
                        {item.expertise.map((tag, tagKey) => {
                            return (
                                <div
                                    className={[
                                        styles.itemTag,
                                        tagKey >= visible
                                            ? styles.itemTagOverflow
                                            : '',
                                    ].join(' ')}
                                    key={`ItemTag-${item.slug}-${tagKey}`}
                                >
                                    {tag.name}
                                </div>
                            );
                        })}
                        {visible < total && (
                            <div ref={plusRef} className={styles.itemPlus}>
                                +{total - visible}
                            </div>
                        )}
                    </div>
                )}
            </a>
        </Link>
    );
};

export default SearchResult;
